<template>
  <v-dialog
    v-model="confirmDialog"
    :content-class="contentClass"
    :fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
    :hide-overlay="$vuetify.breakpoint.smAndDown ? true : false"
    max-width="650"
    width="650"
    id="confirmDialog"
    class="confirmDialog"
  >
    <v-card class="layout px-2 justify-center align-center d-flex">
      <v-row class="flex-column">
        <v-col text-right class="x-close text-left">
          <v-btn icon dark @click="confirmDialog = confirmDialogClose()">
            <v-icon
              class="icon-forma-1-2 d-block mb-1 ml-6 display-16"
              color="primary"
            />
          </v-btn>
        </v-col>

        <v-col class="d-flex flex-column text-center pb-0">
          <v-row justify="center" class="flex-column">
            <v-col class="text-center" mb-4>
              <v-icon
                id="twofin"
                class="d-block mb-1 ml-6 mt-2"
                color="primary"
                :class="icon"
              />
            </v-col>

            <v-col>
              <h3 class="display-34">
                <span v-html="confirmText"></span>
              </h3>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="px-3 pt-1 pb-3">
          <v-row
            class="recommender-box ma-auto px-3"
            justify="center"
            v-if="confirmDialog && !AllowNoCVJob"
          >
            <Recommender
              v-if="confirmDialog && !AllowNoCVJob"
              :currentPage="'recommender_CV Popup'"
              :maxJobs="3"
              :forwardToJobPage="true"
              :displayType="3"
              :displayJobDescription="true"
              :displayMoreJobsBtn="false"
              :displayMoreJobsHeader="true"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
// import Recommender from '~/components/Recommender/Recommender.vue';

export default {
  components: {
    Recommender: () => import('~/components/Recommender/Recommender.vue'),
  },
  props: {},
  data() {
    return {
      confirmDialog: false,
      confirmText: t('titles.CV_Popup.confirmationDialog'),
      confirmTextNocv: t('titles.CV_Popup.confirmationDialogNoCV'),
      AllowNoCVJob: false,
      alertText: t('titles.CV_Popup.alertFailedDialog'),
      fullScreen: false,
      hideOverlay: false,
      transitionType: false,
      contentClass: 'border-radius-20',
      icon: 'icon-fingers',
      alertIcon: 'icon-shape-1-3',
      dialogTimeout: null,

      /** 
      /* 
      /* @param {activateOtpOnPage}  set to true  if cv send from  Hitech category to display OTP.
      */

      activateOtpOnPage: false,
    };
  },

  mounted() {
    this.$nuxt.$on('openConfirmPopup', this.openConfirmation);

    this.$nuxt.$on('alertCVSendFailed', this.openAlert);
    // this.dialogMobile();
  },

  beforeDestroy() {
    this.$nuxt.$off('openConfirmPopup');
    this.$nuxt.$off('alertCVSendFailed');
    clearTimeout(this.dialogTimeout);
  },
  methods: {
    openConfirmation(isHitech, AllowNoCV) {
      /** @param {isHitech } Boolean ,recieved from  CvDialog emit openConfirmPopup ,Will display Phone verifocation popup for hitech only */
      /** @param {AllowNoCV } Boolean , Use for display confirm text for no cv jobs  */
      this.AllowNoCVJob = AllowNoCV;
      // this.activateOtpOnPage = isHitech;
      this.activateOtpOnPage = true; // activate to all users 
      if (this.AllowNoCVJob) this.confirmText = this.confirmTextNocv;

      this.confirmDialog = true;
    },

    confirmDialogClose() {
      // display phone verification popup if results page is Hitech (Temp for a/b testing) . *changed to be open to all users 
      if (this.activateOtpOnPage) {
        this.dialogTimeout = setTimeout(() => {
          this.$nuxt.$emit(
            'openOTP',
            this.AllowNoCVJob ? 'allowNoCVJob' : 'sendCv'
          );
        }, 1500);
      }
    },

    openAlert() {
      this.confirmText = this.alertText;
      this.icon = this.alertIcon;
      this.openConfirmation();
    },
    /**
     * @dialogMobile Adjust CV diaolg on mobile props on mounted.
     * Will display dialog on fullscreen
     */
    dialogMobile() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.fullScreen = true;
        this.hideOverlay = false;
        this.transitionType = 'dialog-bottom-transition';
        this.contentClass = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recommender-box {
  // width: 80%;
  @media only screen and (min-width: 600px) {
    // width: 80%;
  }
}
#twofin {
  font-size: 50px;
}

@media only screen and (min-width: 600px) {
  #twofin {
    font-size: 80px;
  }
}
</style>
